import { useState } from 'react';
import { getFormUrl } from '@/utils/getFormUrl';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('phone_alt') as string || '').trim();
    if (honeypot) {
      setStatus('success');
      setMessage('订阅成功！感谢您的关注。');
      return;
    }

    setStatus('loading');

    try {
      const formUrl = await getFormUrl('九妖漫画网 - 邮件订阅');
      formData.delete('phone_alt');
      const res = await fetch(formUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string } } = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (res.ok && parsed.code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！感谢您的关注。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || '订阅失败，请稍后再试。';
        setStatus('error');
        setMessage(serverMsg);
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查连接后重试。');
    }
  };

  if (status === 'success') {
    return (
      <section className="py-14 bg-accent-500">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 text-center">
          <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-white/20 mb-4">
            <i className="ri-check-line text-3xl text-white"></i>
          </div>
          <h2 className="font-heading text-2xl font-bold text-white mb-2">{message}</h2>
        </div>
      </section>
    );
  }

  return (
    <section className="py-14 md:py-20 bg-accent-500">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-3">
          订阅更新通知
        </h2>
        <p className="text-white/80 text-sm mb-8 max-w-xl mx-auto">
          第一时间获取最新漫画更新、热门推荐和独家福利信息
        </p>

        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row items-center justify-center gap-3 max-w-md mx-auto" data-readdy-form>
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="输入您的邮箱地址"
            className="flex-1 px-5 py-3 text-sm bg-white text-foreground-900 rounded-full placeholder:text-foreground-300 focus:outline-none focus:ring-2 focus:ring-white/50 w-full"
          />
          <input
            type="text"
            name="phone_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="honeypot-field"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="px-6 py-3 bg-foreground-900 text-white rounded-full text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap disabled:opacity-60"
          >
            {status === 'loading' ? '提交中...' : '立即订阅'}
          </button>
        </form>

        {status === 'error' && (
          <p className="text-white/90 text-sm mt-3">{message}</p>
        )}
      </div>
    </section>
  );
}